module.exports = "<div class=\"col-md-7 col-xs-12\">\r\n    <ul>\r\n        <li class=\"paratext\" ng-repeat=\"glossary in glossaryText\" ng-bind-html=\"glossary\"></li>\r\n    </ul>\r\n</div>\r\n\r\n    <div class=\" col-md-5 col-xs-12 \" style=\"\" >\r\n   <div class=\"row\" style=\"margin:330px\" >\r\n            \r\n        </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/apps/dnareport/partials/glossary.html
// module id = 91
// module chunks = 0